<script>
import { getSpecificArticleFromStore, replaceMaHcLoginSupportContent } from '@/utils/common';

export default {
  data() {
    return {
      openArticleIds: [],
    };
  },
  updated() {
    replaceMaHcLoginSupportContent();
  },
  computed: {
    articles() {
      const faq_1 = getSpecificArticleFromStore('4402562474900') || {};
      const faq_2 = getSpecificArticleFromStore('8913861027604') || {};
      const faq_3 = getSpecificArticleFromStore('8913868313748') || {};
      const faq_4 = getSpecificArticleFromStore('8913928666260') || {};
      const faq_5 = getSpecificArticleFromStore('8913908785684') || {};
      const faq_6 = getSpecificArticleFromStore('360061126572') || {};
      const faq_7 = getSpecificArticleFromStore('8913965231636') || {};
      const faq_8 = getSpecificArticleFromStore('8913967568148') || {};
      const faq_9 = getSpecificArticleFromStore('8914003910420') || {};
      const faq_10 = getSpecificArticleFromStore('8914006051988') || {};

      return [
        faq_1,
        faq_2,
        faq_3,
        faq_4,
        faq_5,
        faq_6,
        faq_7,
        faq_8,
        faq_9,
        faq_10
      ];
    },
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds.indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    },
    showArticle(e) {
      let articleId = e.target.dataset.article;
      let element = document.querySelector(`#art-${articleId}`);
      let svg = document.querySelector(`#icon-${articleId}`);
      if (this.openArticleIds.includes(articleId)) {
        element.style['max-height'] = `0px`;
        element.classList.remove('active');
        svg.classList.remove('svg-open');
        this.handleArticleClick(articleId);
        return;
      }
      element.style['max-height'] = `${element.scrollHeight}px`;
      element.style['transition'] = '0.5s';
      this.handleArticleClick(articleId);
      element.classList.add('active');
      svg.classList.add('svg-open');
      this.activeArticle = articleId;

    }
  }
}
</script>

<template>
  <div class="faq">
    <div class="faq-container">
      <h1 class="faq-title">Frequently Asked Questions</h1>
      <div class="articles">
        <div>
          <ul class="list pa0 ma0">
            <li class="faq-article" v-for="article in articles" :key="article.name">
              <button
                  class="article-button"
                  @click.stop="showArticle"
                  :data-article="article.id"
                  :class="{
              'article-button--active': openArticleIds.includes(article.id)
            }"
              >
                <a
                    style="color: inherit; text-decoration: inherit;"
                    :data-article="article.id"
                >
                  {{ article.title }}
                  <svg
                      :data-article="article.id"
                      :id="`icon-${article.id}`"
                      viewBox="-1 -1 22 22"
                      class='svg-icon'
                      focusable="true"
                  >
                    <path d="M10.5 9.3L1.8 0.5 0.5 1.8 9.3 10.5 0.5 19.3 1.8 20.5 10.5 11.8 19.3 20.5 20.5 19.3 11.8 10.5 20.5 1.8 19.3 0.5 10.5 9.3Z"></path>
                  </svg>
                </a>
              </button>
              <div :id="`art-${article.id}`" class="article-body">
                <div v-html="article.body" data-external="articles" class="faq-article-body"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/lsweepshc-design.scss';

@media (max-width: 641px) {
  .faq-title {
    font-size: 30px !important;
  }

  .article-button {
    font-size: 18px !important;
  }
}

.svg-icon {
  fill: #fff;
  height: 26px;
  position: absolute;
  right: 1em;
  top: 50%;
  transform: translateY(-50%) rotate(-45deg);
  width: 26px;

  @media (max-width: 641px) {
    right: 12px;
    width: 22px;
    height: 22px;
  }
}

.svg-open {
  transform: translateY(-50%);
}

.faq-article {
  background: #303030;
  margin-bottom: 8px;
}

.faq-title {
  font-weight: 700;
  font-size: 40px;
  line-height: 49px;
  color: #fff !important;
  font-family: 'Montserrat' !important;
  letter-spacing: 1.26px;
}
.faq {
  text-align: center;
  background: #000 !important;
}

.faq-container {
  max-width: 815px;
  margin: 0 auto;
  padding: 72px 0px 124px 0px;
}

.faq-article-body {
  padding: 10px 30px 25px 30px;

  @media (max-width: 641px) {
    padding: 10px 18px 25px;
  }
}
.articles {
  margin-top: 59px;

  .title {
    margin-bottom: 0.2rem;
    font-size: 32px;
  }
}

.article-button {
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  color: #fff !important;
  text-align: left;
  cursor: pointer;
  line-height: 30px;
  transition: 0.1s linear color;
  padding: 17px 55px 17px 30px;
  width: 100%;
  font-size: 22px;
  position: relative;

  @media (max-width: 641px) {
    padding: 17px 43px 17px 18px;
  }

  a {
    font-family: 'Open Sans', sans-serif !important;
    font-weight: 700;
  }
  &:hover {
    color: #b4b4b4;
  }
  &--active {
    margin: 0;
  }
}
.article-body {
  // -webkit-transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); /* For Safari 3.1 to 6.0 */
  transition: 1s;
  max-height: 0px;
  overflow: hidden;
  font-size: 1.1rem;
  color: #fff !important;
  text-align: left;
  font-family: 'Open Sans', sans-serif !important;

  a {
    color: $theme-highlight;
    text-decoration: none;
  }
}
.faq-article-body ::v-deep p {
  margin: 0;
}
.container {
  display: flex;
}
.button__show-more {
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: #3bb4ef;
  flex: 1 1 auto;
  text-align: center;
  margin: 0;
  padding: 0;

  &:hover {
    background-color: transparent;
    color: #3bb4ef;
    text-decoration: underline;
  }

  svg {
    display: inline-block;
    margin-left: 1px;
    vertical-align: middle;
  }
}
</style>
